<template>
  <div class="pointList">
    <div class="intes-bt" v-if="report_type !== '营养评估'">本次总评</div>
    <div class="intes-pfBox intes-bg"  v-if="report_type !== '营养评估'">
      <div class="intes-pfBox-num">
        <span
          class="span1"
          :class="status == '减弱' ? 'jr' : status == '普通' ? 'pt' : 'jq'"
          >{{ marks }}</span
        >
        <span class="span2">{{ status }}</span>
      
      </div>
    </div>
    <van-cell
      is-link
      v-for="(item, index) in list"
      :key="index"
      @click="detail(item.name, list)"
    >
      <template #title>
        <div class="pointImg">
          <img :src="require(`@/assets/image/chang/${item.name}.png`)" />{{
            item.name
          }}
        </div>
      </template>
    </van-cell>
  </div>
</template>
<script>
import EchartsGauge from "./EchartsGauge.vue"
export default {
  props: ['list', 'marks', 'status','report_type'],
  components: { EchartsGauge },
  data () {
    return {
      risklist: []
    }
  },
  watch: {
    list (newVal) {
      this.list = newVal;
    }
  },
  methods: {
    detail (item, list) {
      this.$router.push({ path: '/noteDetail', query: { item: item, list: JSON.stringify(list) } });
    }
  }
}
</script>
<style lang="scss" scoped>
.intes-pfBox {
  margin-bottom: 20px;
  .intes-pfBox-num {
    border-bottom: 1px solid #ebedf0;
    text-align: center;
    background: url("~@/assets/image/chang/pingfen-bg.png") no-repeat;
    background-size: 100% 100%;
    padding-top: 0px;
    height: 350px;
    padding: 80px 0 0 0;
    box-sizing: border-box;
    font-weight: bold;
    text-shadow: 0px 8px 0px rgba(91, 145, 190, 0.28);
    span {
      display: inline-block;
      width: 100%;
    }
    .span1 {
      font-size: 120px;
      color: #fff;
    }
    .span2 {
      font-size: 40px;
      font-weight: bold;
      color: #fff;
      margin-top: 8px;
    }
    .jr {
      color: #3195e6;
    }
    .pt {
      color: #9ef133;
    }
    .jq {
      color: #f1be33;
    }
  }
}
</style>